import React from "react";
import { Button } from "@/components/ui/button";
import { Plus, Trash2 } from "lucide-react";
import { Person } from "../types";

interface PersonNavigationProps {
  items: Person[][];
  activeIndex: number;
  onSelectIndex: (index: number) => void;
  onAddItem: () => void;
  onRemoveItem: (index: number) => void;
  addButtonLabel?: string;
}

const PersonNavigation: React.FC<PersonNavigationProps> = ({
  items,
  activeIndex,
  onSelectIndex,
  onAddItem,
  onRemoveItem,
  addButtonLabel = "Adicionar"
}) => {
  // Se não houver itens, mostrar apenas o botão para adicionar
  if (!items.length) {
    return (
      <div className="mt-4 flex justify-center">
        <div 
          onClick={onAddItem}
          className="flex items-center justify-center w-[35px] h-[35px] bg-primary cursor-pointer rounded-md"
          title={addButtonLabel}
        >
          <Plus size={16} color="white" />
        </div>
      </div>
    );
  }
  
  return (
    <div className="flex flex-col-reverse sm:flex-row justify-center items-center gap-1 sm:gap-4 w-full relative mb-6">
      <div className="flex gap-2">
        {items.map((_, index) => (
          <div 
            key={index} 
            onClick={() => onSelectIndex(index)} 
            className="flex flex-col justify-between items-center w-[35px] h-[49px] cursor-pointer"
          >
            <div className={`flex items-center justify-center w-[35px] h-[35px] rounded-md ${index === activeIndex ? 'bg-primary' : 'bg-background/10'}`}>
              <span className="text-background text-xs sm:text-base">
                {(index + 1).toString().padStart(2, '0')}
              </span>
            </div>
            {index === activeIndex && (
              <span className="w-full h-[5px] rounded-xs bg-primary" />
            )}
          </div>
        ))}
      </div>
      
      <div className="flex self-end gap-2 sm:absolute right-0 top-0">
        {items.length > 0 && (
          <Button 
            onClick={() => onRemoveItem(activeIndex)} 
            variant="destructive" 
            className="h-[35px] text-background rounded-md bg-background/10 hover:bg-background/10 my-0 py-0 has-[>svg]:px-2"
          >
            <Trash2 size={16} />
          </Button>
        )}
        <div 
          onClick={onAddItem}
          className="flex items-center justify-center w-[35px] h-[35px] bg-primary cursor-pointer rounded-md"
        >
          <Plus size={16} />
        </div>
      </div>
    </div>
  );
};

export default PersonNavigation; 